import React from 'react';
import { connect } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars-2';


const mapStateToProps = (state) => {
  return {
    portrait: state.user.portrait,
  }
}

const Page = ({ children, portrait }) => {
  // console.log("portrait", portrait)
  return portrait
    ? <div className='page-portrait'>{children}</div>
    : <div className='page'>{children}</div>
};

export default connect(mapStateToProps)(Page);

const ContentWithScroll = ({ children }) => <Scrollbars
  className='page-content scroll'
  id='page-content'
>
  {children}
</Scrollbars>;

const ContentNoScroll = ({ children }) => <div
  className='page-content'
  id='page-content'
>
  {children}
</div>;

export const Content = ({ scroll, ...props }) => scroll ?
  <ContentWithScroll {...props} />
  :
  <ContentNoScroll {...props} />;